const routes = [
  {
    path: '/mall',
    component: () => import('@/layouts/tabBar.vue'),
    children: [
      {
        path: '/mall',
        name: 'mallIndex',
        component: () => import('@/pages/mall/index.vue'),
        meta: {
          title: '商城',
          notAuth: true,
          keepAlive: true
        }
      },
      {
        path: '/user',
        name: 'userIndex',
        component: () => import('@/pages/user/index.vue'),
        meta: {
          title: '个人中心',
          keepAlive: true
        }
      },
      {
        path: '/mall/view',
        name: 'mallView',
        component: () => import('@/pages/mall/view.vue'),
        meta: {
          title: '商品详情',
          keepAlive: false,
          notAuth: true
        }
      },
      {
        path: '/order/pay',
        name: 'pay',
        component: () => import('@/pages/mall/pay.vue'),
        meta: {
          title: '确认订单',
          keepAlive: false
        }
      },
      {
        path: '/pay/result',
        name: 'payresult',
        component: () => import('@/pages/mall/result.vue'),
        meta: {
          title: '支付结果',
          keepAlive: false
        }
      },
      {
        path: '/order',
        name: 'order',
        component: () => import('@/pages/mall/order.vue'),
        meta: {
          title: '订单查询',
          keepAlive: false
        }
      },
      {
        path: '/order/view',
        name: 'orderView',
        component: () => import('@/pages/mall/orderView.vue'),
        meta: {
          title: '订单详情',
          keepAlive: false
        }
      },
      {
        path: '/activity/order',
        name: 'activityOrder',
        component: () => import('@/pages/activity/orderView.vue'),
        meta: {
          title: '订单详情',
          keepAlive: false
        }
      },
      {
        path: '/mall/search',
        name: 'search',
        component: () => import('@/pages/mall/search.vue'),
        meta: {
          title: '商品搜索',
          keepAlive: true,
          noTabbar: true,
          notAuth: true
        }
      }
    ]
  },
  {
    path: '',
    component: () => import('@/layouts/default.vue'),
    children: [
      {
        path: '/questionnaire',
        name: 'questionnaireIndex',
        component: () => import('@/pages/questionnaire/index.vue'),
        meta: {
          title: '调查问卷',
          notAuth: true
        }
      },
      {
        path: '/questionnaire/list',
        name: 'questionnaireList',
        component: () => import('@/pages/questionnaire/list.vue'),
        meta: {
          title: '调查问卷',
          notAuth: true
        }
      },
      {
        path: '/questionnaire/patrolman',
        name: 'patrolman',
        component: () => import('@/pages/questionnaire/patrolman.vue'),
        meta: {
          title: '广东自然保护地“最美巡护员”评选',
          notAuth: true
        }
      },
      {
        path: '/questionnaire/patrolmanRanking',
        name: 'patrolmanRanking',
        component: () => import('@/pages/questionnaire/patrolmanRanking.vue'),
        meta: {
          title: '广东自然保护地“最美巡护员”评选',
          notAuth: true
        }
      },
      {
        path: '/questionnaire/ranking',
        name: 'questionnairRanking',
        component: () => import('@/pages/questionnaire/ranking.vue'),
        meta: {
          title: '调查问卷',
          notAuth: true
        }
      },
      {
        path: '/result',
        name: 'result',
        component: () => import('@/pages/result.vue'),
        meta: {
          title: '答题完毕',
          notAuth: true
        }
      },
      {
        path: '/activity/result',
        name: 'activityResult',
        component: () => import('@/pages/activity/result.vue'),
        meta: {
          title: '报名结果',
          notAuth: true
        }
      },
      {
        path: '/exam',
        name: 'exmaIndex',
        component: () => import('@/pages/exam/index.vue'),
        meta: {
          title: '在线考试',
          notAuth: true
        }
      },
      {
        path: '/exam/list',
        name: 'exmaList',
        component: () => import('@/pages/exam/list.vue'),
        meta: {
          title: '问卷调查',
          notAuth: true
        }
      },
      {
        path: '/exam/result',
        name: 'examResult',
        component: () => import('@/pages/exam/result.vue'),
        meta: {
          title: '答题完毕',
          notAuth: true
        }
      },
      {
        path: '/activity',
        name: 'activityIndex',
        component: () => import('@/pages/activity/index.vue'),
        meta: {
          title: '活动',
          notAuth: true
        }
      },
      {
        path: '/activity/view',
        name: 'activityView',
        component: () => import('@/pages/activity/view.vue'),
        meta: {
          title: '活动详情',
          notAuth: true
        }
      },
      {
        path: '/activity/form',
        name: 'activityForm',
        component: () => import('@/pages/activity/form.vue'),
        meta: {
          title: '活动报名'
        }
      },
      {
        path: '/address',
        name: 'address',
        component: () => import('@/pages/address/index.vue'),
        meta: {
          title: '地址管理'
        }
      },
      {
        path: '/address/form',
        name: 'addressForm',
        component: () => import('@/pages/address/form.vue'),
        meta: {
          title: '新增地址'
        }
      },
      {
        path: '/binding',
        name: 'binding',
        component: () => import('@/pages/binding.vue'),
        meta: {
          title: '绑定手机'
        }
      },
      {
        path: '/myActivity',
        name: 'myActivity',
        component: () => import('@/pages/user/activity/index.vue'),
        meta: {
          title: '我的报名'
        }
      },
      {
        path: '/myActivity/view',
        name: 'myActivityView',
        component: () => import('@/pages/user/activity/view.vue'),
        meta: {
          title: '报名详情'
        }
      },
      {
        path: '/myExam',
        name: 'myExam',
        component: () => import('@/pages/user/exam/index.vue'),
        meta: {
          title: '我的考试',
          keepAlive: true
        }
      },
      {
        path: '/myExam/view',
        name: 'myExamView',
        component: () => import('@/pages/user/exam/view.vue'),
        meta: {
          title: '考试详情'
        }
      },
      {
        path: '/exam/ranking',
        name: 'examRanking',
        component: () => import('@/pages/user/exam/ranking.vue'),
        meta: {
          title: '排行榜'
        }
      },
      {
        path: '/myQuestionnaire',
        name: 'myQuestionnaire',
        component: () => import('@/pages/user/questionnaire/index.vue'),
        meta: {
          title: '我的问卷',
          keepAlive: true
        }
      },
      {
        path: '/myQuestionnaire/view',
        name: 'myQuestionnaireView',
        component: () => import('@/pages/user/questionnaire/view.vue'),
        meta: {
          title: '问卷详情'
        }
      },
      {
        path: '/topic',
        name: 'topic',
        component: () => import('@/pages/topic/topic1/index.vue'),
        meta: {
          title: '广东省科协全委会',
          topic: 'topic'
        }
      },
      {
        path: '/topic/login',
        name: 'topicLogin',
        component: () => import('@/pages/topic/topic1/login.vue'),
        meta: {
          title: '广东省科协全委会',
          notAuth: true
        }
      },
      {
        path: '/topic2',
        name: 'topic2',
        component: () => import('@/pages/topic/topic2/index.vue'),
        meta: {
          title: '广东省环境科学学会',
          topic: 'topic2'
        }
      },
      {
        path: '/topic2/login',
        name: 'topic2Login',
        component: () => import('@/pages/topic/topic2/login.vue'),
        meta: {
          title: '广东省环境科学学会',
          notAuth: true
        }
      },
      {
        path: '/topic3',
        name: 'topic3',
        component: () => import('@/pages/topic/topic3/index.vue'),
        meta: {
          title: '韶关市科学技术协会八届五次全委',
          topic: 'topic3'
        }
      },
      {
        path: '/topic3/login',
        name: 'topic3Login',
        component: () => import('@/pages/topic/topic3/login.vue'),
        meta: {
          title: '韶关市科学技术协会八届五次全委',
          notAuth: true
        }
      },
      {
        path: '/topic2022',
        name: 'topic2022',
        component: () => import('@/pages/topic/topic4/index.vue'),
        meta: {
          title: '广东省科学技术协会九届五次全委会通讯会议',
          topic: 'topic2022'
        }
      },
      {
        path: '/topic2022/login',
        name: 'topic2022Login',
        component: () => import('@/pages/topic/topic4/login.vue'),
        meta: {
          title: '广东省科学技术协会九届五次全委会通讯会议',
          notAuth: true
        }
      },
      {
        path: '/competition',
        name: 'competitionEnter',
        component: () => import('@/pages/custom/competition/enter.vue'),
        meta: {
          title: '林业科普知识挑战赛'
        }
      },
      {
        path: '/competition/index',
        name: 'competition',
        component: () => import('@/pages/custom/competition/index.vue'),
        meta: {
          title: '林业科普知识挑战赛'
        }
      },
      {
        path: '/competition/practice',
        name: 'competitionPractice',
        component: () => import('@/pages/custom/competition/practice.vue'),
        meta: {
          title: '林业科普知识挑战赛'
        }
      },
      {
        path: '/competition/exam',
        name: 'competitionExam',
        component: () => import('@/pages/custom/competition/exam.vue'),
        meta: {
          title: '林业科普知识挑战赛'
        }
      },
      {
        path: '/competition/lucklottery',
        name: 'luckLottery',
        component: () => import('@/pages/custom/competition/lucklottery.vue'),
        meta: {
          title: '抽奖中心'
        }
      },
      {
        path: '/competition/winningrecord',
        name: 'winningRecord',
        component: () => import('@/pages/custom/competition/winningrecord.vue'),
        meta: {
          title: '中奖记录'
        }
      },
      {
        path: '/challenges',
        name: 'challengesEnter',
        component: () => import('@/pages/custom/challenges/enter.vue'),
        meta: {
          title: '自然保护地知识挑战赛'
        }
      },
      {
        path: '/challenges/index',
        name: 'challenges',
        component: () => import('@/pages/custom/challenges/index.vue'),
        meta: {
          title: '自然保护地知识挑战赛'
        }
      },
      {
        path: '/challenges/practice',
        name: 'challengesPractice',
        component: () => import('@/pages/custom/challenges/practice.vue'),
        meta: {
          title: '自然保护地知识挑战赛'
        }
      },
      {
        path: '/challenges/exam',
        name: 'challengesExam',
        component: () => import('@/pages/custom/challenges/exam.vue'),
        meta: {
          title: '自然保护地知识挑战赛'
        }
      },
      {
        path: '/challenges/lucklottery',
        name: 'challengesLucklottery',
        component: () => import('@/pages/custom/challenges/lucklottery.vue'),
        meta: {
          title: '抽奖中心'
        }
      },
      {
        path: '/challenges/winningrecord',
        name: 'challengesWinningRecord',
        component: () => import('@/pages/custom/challenges/winningrecord.vue'),
        meta: {
          title: '中奖记录'
        }
      },
      {
        path: '/aviation',
        name: 'aviationEnter',
        component: () => import('@/pages/custom/aviation/enter.vue'),
        meta: {
          title: '航空科普知识挑战赛'
        }
      },
      {
        path: '/aviation/portal',
        name: 'aviationPortal',
        component: () => import('@/pages/custom/aviation/portal.vue'),
        meta: {
          title: '航空科普知识挑战赛'
        }
      },
      {
        path: '/aviation/index',
        name: 'aviation',
        component: () => import('@/pages/custom/aviation/index.vue'),
        meta: {
          title: '航空科普知识挑战赛'
        }
      },
      {
        path: '/aviation/exam',
        name: 'aviationExam',
        component: () => import('@/pages/custom/aviation/exam.vue'),
        meta: {
          title: '航空科普知识挑战赛'
        }
      },
      {
        path: '/aviation/practice',
        name: 'aviationPractice',
        component: () => import('@/pages/custom/aviation/practice.vue'),
        meta: {
          title: '航空科普知识挑战赛'
        }
      },
      {
        path: '/aviation/lucklottery',
        name: 'aviationLucklottery',
        component: () => import('@/pages/custom/aviation/lucklottery.vue'),
        meta: {
          title: '抽奖中心'
        }
      },
      {
        path: '/aviation/winningrecord',
        name: 'aviationWinningRecord',
        component: () => import('@/pages/custom/aviation/winningrecord.vue'),
        meta: {
          title: '中奖记录'
        }
      },
      {
        path: '/login',
        name: 'login',
        component: () => import('@/pages/login.vue'),
        meta: {
          title: '用户登录',
          notAuth: true
        }
      },
      {
        path: '/',
        redirect: '/activity'
      }
    ]
  }
]

export default routes